import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "text-subtitle-2 font-weight-bold mb-1" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "text-subtitle-2 font-weight-bold mb-1" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "text-subtitle-2 font-weight-bold mb-1" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "text-subtitle-2 font-weight-bold mb-1" }

import { useGlobalSetting } from '@/lib/utils'

interface Props {
  onAccept?: () => void
  onClose?: () => void
}

const STORAGE_KEY = 'agb_accepted'


export default /*@__PURE__*/_defineComponent({
  __name: 'AGB',
  props: {
    onAccept: { type: Function },
    onClose: { type: Function }
  },
  emits: ["accept", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const globalSettings = useGlobalSetting()

const accept = () => {
  localStorage.setItem(STORAGE_KEY, new Date().toISOString())
  emit('accept')
  props.onAccept?.()
  props.onClose?.()
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "mr-2",
            color: "primary"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("mdi-file-document-outline")
            ])),
            _: 1,
            __: [0]
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" Allgemeine Nutzungsbedingungen "))
        ]),
        _: 1,
        __: [1]
      }),
      _createVNode(_component_v_card_text, {
        class: "text-body-2",
        style: {"max-height":"60vh","overflow-y":"auto"}
      }, {
        default: _withCtx(() => [
          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-body-1 font-weight-medium mb-4" }, " Bitte lies die folgenden Nutzungsbedingungen sorgfältig durch, bevor du diese Anwendung verwendest. ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "18",
                class: "mr-1"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-currency-usd-off")
                ])),
                _: 1,
                __: [2]
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" 1. Nicht-kommerzieller Zweck "))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, " Diese Webanwendung wird ausschließlich zu nicht-kommerziellen Zwecken betrieben. Es werden keine Einnahmen durch die Nutzung dieser Seite erzielt. Es handelt sich um ein internes Werkzeug ohne Gewinnerzielungsabsicht. Es besteht kein Anspruch auf Verfügbarkeit, Funktionalität oder Weiterentwicklung der Anwendung. ", -1))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                size: "18",
                class: "mr-1"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-shield-lock-outline")
                ])),
                _: 1,
                __: [5]
              }),
              _cache[6] || (_cache[6] = _createTextVNode(" 2. Datenschutz und sensible Daten "))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, [
              _createTextVNode(" Es ist ausdrücklich "),
              _createElementVNode("strong", null, "untersagt"),
              _createTextVNode(", private, personenbezogene oder firmenbezogene vertrauliche Daten in dieser Anwendung einzugeben oder zu speichern. Dazu gehören unter anderem: ")
            ], -1)),
            _cache[8] || (_cache[8] = _createElementVNode("ul", { class: "ml-4 mt-1" }, [
              _createElementVNode("li", null, "Persönliche Kontaktdaten (private Adressen, Telefonnummern, etc.)"),
              _createElementVNode("li", null, "Passwörter oder Zugangsdaten für andere Systeme"),
              _createElementVNode("li", null, "Vertrauliche Geschäfts- oder Betriebsgeheimnisse"),
              _createElementVNode("li", null, "Personenbezogene Daten Dritter ohne deren Einwilligung")
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-2" }, " Die Nutzung erfolgt auf eigene Verantwortung. Der Betreiber übernimmt keine Verantwortung für Daten, die entgegen dieser Regelung eingegeben werden. ", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_icon, {
                size: "18",
                class: "mr-1"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-alert-circle-outline")
                ])),
                _: 1,
                __: [10]
              }),
              _cache[11] || (_cache[11] = _createTextVNode(" 3. Haftungsausschluss "))
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("p", null, [
              _createTextVNode(" Die Nutzung dieser Anwendung erfolgt auf eigenes Risiko. Der Betreiber übernimmt "),
              _createElementVNode("strong", null, "keinerlei Haftung"),
              _createTextVNode(" für: ")
            ], -1)),
            _cache[13] || (_cache[13] = _createElementVNode("ul", { class: "ml-4 mt-1" }, [
              _createElementVNode("li", null, "Datenverlust oder -beschädigung jeglicher Art"),
              _createElementVNode("li", null, "Fehlerhafte Darstellung, Berechnung oder Verarbeitung von Daten"),
              _createElementVNode("li", null, "Ausfälle, Unterbrechungen oder Nichterreichbarkeit der Anwendung"),
              _createElementVNode("li", null, "Schäden, die durch die Nutzung oder Nichtnutzung der bereitgestellten Informationen entstehen"),
              _createElementVNode("li", null, "Schäden durch unbefugten Zugriff Dritter auf gespeicherte Daten")
            ], -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mt-2" }, [
              _createTextVNode(" Die Anwendung wird ohne jegliche Gewährleistung bereitgestellt ("),
              _createElementVNode("em", null, "\"as is\""),
              _createTextVNode("). Es wird keine Garantie für die Richtigkeit, Vollständigkeit oder Aktualität der angezeigten Daten übernommen. ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                size: "18",
                class: "mr-1"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("mdi-gavel")
                ])),
                _: 1,
                __: [15]
              }),
              _cache[16] || (_cache[16] = _createTextVNode(" 4. Sonstige Bestimmungen "))
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("ul", { class: "ml-4" }, [
              _createElementVNode("li", null, " Der Betreiber behält sich das Recht vor, diese Nutzungsbedingungen jederzeit und ohne Vorankündigung zu ändern. Die fortgesetzte Nutzung nach Änderungen gilt als Zustimmung zu den aktualisierten Bedingungen. "),
              _createElementVNode("li", null, " Der Betreiber behält sich vor, Benutzerkonten ohne Angabe von Gründen zu sperren oder zu löschen, insbesondere bei Verstoß gegen diese Nutzungsbedingungen. "),
              _createElementVNode("li", null, " Sollte eine Bestimmung dieser Nutzungsbedingungen unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt. "),
              _createElementVNode("li", null, " Es gilt das Recht der Bundesrepublik Deutschland. ")
            ], -1))
          ]),
          _createVNode(_component_v_divider, { class: "my-3" }),
          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-caption text-medium-emphasis" }, " Stand: März 2026 | Bei Fragen wende dich an den Betreiber der Anwendung. ", -1))
        ]),
        _: 1,
        __: [18,19]
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: _unref(globalSettings).globalButtonVariant,
            size: "large",
            onClick: accept
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode(" Akzeptieren und fortfahren ")
            ])),
            _: 1,
            __: [20]
          }, 8, ["variant"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})